export default __webpack_public_path__ + "static/media/2023_Spaak_et_al_2023_TheoreticalEcology.519b102c.pdf";